import { useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import apiRequest from "api/apiRequest";
import { UserContext } from "context/user";

const fetchCatalog = async (query, token) => {
  const response = await apiRequest.get(`v2/captures?${query}`, {
    headers: {
      authorization: `Bearer ${token}`,
      "df-api-key": process.env.REACT_APP_DF_API_KEY,
    },
  });

  return response.data.data;
};

export const useCatalogQuery = (query) => {
  const { token } = useContext(UserContext);

  return useQuery(["catalog", query, token], () => fetchCatalog(query, token));
};
